import {
  CustomFieldSelectAttribute,
  CustomFieldSelectAttributeOption,
} from 'apis/customFields';
import { treeFilter } from 'utils/tree';

/**
 * Patches a custom select attribute so it's easier to compare.
 *
 * @param attribute The select attribute to patch.
 */
export function patchSelectAttribute(
  attribute: CustomFieldSelectAttribute,
): CustomFieldSelectAttribute {
  const filteredOptions = JSON.parse(
    JSON.stringify(
      treeFilter(
        attribute.options ?? [],
        ({ label, value }) => !!label && !!value,
        'options',
      ),
      (key, value) => {
        if (key === 'options' && Array.isArray(value) && value.length === 0) {
          return;
        }

        return value;
      },
    ),
  ) as readonly CustomFieldSelectAttributeOption[];

  return Object.assign({}, attribute, {
    options: filteredOptions,
  }) as CustomFieldSelectAttribute;
}
